import { render, staticRenderFns } from "./MessageTemplatesTable.vue?vue&type=template&id=5fdb2332&"
import script from "./MessageTemplatesTable.vue?vue&type=script&lang=js&"
export * from "./MessageTemplatesTable.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplatesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
